import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import InfoBox from '../../../info-box';

type Props = {
    onComplete?: () => void
}

const Task202: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-202');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-202">
        <h2>zadanie 2</h2>
        <h3>{task?.title}</h3>
        <div className="decor-3">
            <p>
                Czy słyszeliście o Międzynarodowym Tygodniu Pisania Listów? W tym roku odbywa się już 52. edycja tej akcji, która rozpoczyna się 9 października. Dawniej tradycyjne listy były jedyna formą rozmowy na odległość. Wyobrażacie sobie, że piszecie do kogoś wiadomość i czekacie tygodnie (a czasem miesiące!) na odpowiedź? Współcześnie nie do pomyślenia, prawda?
            </p>
        </div>
        <p className="instruction">
            <strong>Zadanie:</strong> Napiszcie list, w którym opiszecie, jakie emocje wywołuje w Was ulubiona książka i co sprawia, że to właśnie ona jest tą najlepszą. List włóżcie do koperty, napiszcie na nim nazwę książki i zanieście do biblioteki. Jeżeli to możliwe, to włóżcie kopertę do książki, którą opisywaliście.
        </p>
        <InfoBox>
            <p>
                Jeśli w Waszej bibliotece nie ma tej książki, przekażcie kopertę pracownikowi biblioteki i poproście, żeby przekazał ją pierwszej osobie, która wypożyczy pozycję tego autora lub gatunku!
            </p>
        </InfoBox>
    </div>
}

export default Task202;
